function get(date1, date2) {
    return window.axios.get('https://transapi.hifos.com.mx/api/detail-report', { params: { start_date: date1, end_date: date2 } });
}

export default {
    get
}